
import { Vue, Component } from 'vue-property-decorator';
import PrintReturnCard from '@/features/shipment/components/print/PrintReturnCard.vue';

@Component({
  components: {
    PrintReturnCard,
  },
})
export default class Return extends Vue {}
